export default "__VITE_ASSET__CoYchbGw__"